// SemanticUI-free pre-@plone/components
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import SearchWidget from '../../../../../components/SearchWidget/SearchWidget';

//export default SearchWidget;
export default compose(withRouter, injectIntl)(SearchWidget);
